import { NepaliDate, toBS, toAD } from '@zener/nepali-datepicker-react';

/**
 * Format a date (AD) to BS (Bikram Sambat) with Nepali numerals
 * @param {string|Date} date - AD date to convert
 * @returns {string} - Formatted BS date like "२०८२-१२-१७"
 */
export const formatDateBS = (date) => {
    if (!date) return '';

    try {
        const dateObj = new Date(date);
        if (isNaN(dateObj.getTime())) return '';

        const nepaliDate = new NepaliDate(dateObj);

        // This is the most reliable way to get Nepali digits (YYYY-MM-DD)
        return nepaliDate.format('YYYY-MM-DD', 'np');
    } catch (error) {
        console.error('Error formatting BS date:', error);
        return '';
    }
};

/**
 * Parse BS date string back to JavaScript Date (AD)
 * Supports both Nepali digits (२०८२-१२-१७) and English digits (2082-12-17)
 * @param {string} bsDateStr - BS date string
 * @returns {Date|null}
 */
export const parseBSDate = (bsDateStr) => {
    if (!bsDateStr || typeof bsDateStr !== 'string') return null;

    try {
        // Convert Nepali digits to English digits if present
        const normalized = bsDateStr.replace(/[०-९]/g, (digit) => {
            return '०१२३४५६७८९'.indexOf(digit).toString();
        });

        // Split and validate
        const parts = normalized.split('-');
        if (parts.length !== 3) return null;

        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);

        if (!year || !month || !day) return null;

        // Use library's toAD function
        const adDate = toAD(`${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`);

        if (!adDate || !adDate.year) return null;

        return new Date(adDate.year, adDate.month - 1, adDate.date);
    } catch (error) {
        console.error('Error parsing BS date:', error);
        return null;
    }
};

/**
 * Simple AD date formatter (using native JS - more reliable)
 * @param {string|Date} date 
 * @returns {string} e.g. "2025-03-31"
 */
export const formatDateAD = (date) => {
    if (!date) return '';
    try {
        const d = new Date(date);
        if (isNaN(d.getTime())) return '';

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`; // YYYY-MM-DD
    } catch (error) {
        console.error('Error formatting AD date:', error);
        return '';
    }
};